/**
 * Ends CPL tracking
 * @param {String} identifier for identifying which recordCplStart to end
 * @param {Object} data object containing additional data to track
 */
export function recordCplEnd(identifier, data) {
  data = data || {}

  // Automatically add 'devexp_' prefix to event_name if not already present
  if (data.event_name && !data.event_name.startsWith('devexp_')) {
    data.event_name = `devexp_${data.event_name}`
  }

  try {
    if (identifier) {
      window.PAYPAL.analytics.endCPLTracking(data, identifier)
    } else {
      window.PAYPAL.analytics.endCPLTracking(data)
    }
  } catch {
    return
  }
}
